<template>
  <div class="form">
    <Loading
      v-if="loadingSaveData"
      class="mb-2"
    />

    <div class="form-group">
      <label
        for="name"
        v-if="upload"
      >{{$t('admin.engraving_text.form.name')}}</label>
      <div class="flex items-center">
        <input
          id="name"
          type="text"
          style="width: 100%"
          v-model="form.name"
        />
      </div>
      <ValidationErrors :errors="errorsFor('name')" />
    </div>

    <div
      class="form-group"
      v-if="upload"
    >

      <FileInputBlock
        :notPreview="true"
        :prefill="null"
        :selectedImageFileNameDefault="$t('admin.engraving_text.form.font_not_selected')"
        :alreadyLoadText="$t('admin.engraving_text.form.font_selected')"
        :loadedFile="null"
        @selected-file="(file) => selectFile(file, 'File')"
      >

      </FileInputBlock>
      <ValidationErrors :errors="errorsFor('file')" />
    </div>

    <div class="form-group text-right">
      <button
        @click="saveData"
        class="btn btn-small btn-green"
      >
        <span v-if="upload">
          {{$t('admin.engraving_text.form.save')}}
        </span>
        <span v-if="edit">
          {{$t('admin.engraving_text.form.edit')}}
        </span>

      </button>
    </div>
  </div>
</template>

<script>
import validationErrors from "../../../mixins/validationErrors";

export default {
  name: "FormEngravingText",
  mixins: [validationErrors],
  props: {
    edit: {
      type: Object,
    },
    upload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loadingSaveData: false,
      form: {
        name: "",
        selectedFile: null,
      },
    };
  },
  mounted() {
    if (this.edit) {
      this.form.name = this.edit.name;
    }
  },
  methods: {
    selectFile(file, dataProps) {
      this.form[`selected${dataProps}`] = file;
    },
    async saveData() {
      this.errors = null;
      this.loadingSaveData = true;

      try {
        let formDataPost = new FormData();

        if (this.edit) formDataPost.append("_method", "PATCH");

        formDataPost.append("name", this.form.name);

        if (this.form.selectedFile !== null) {
          formDataPost.append("file", this.form.selectedFile);
        }

        let url = "/api/admin/fonts";
        if (this.edit) url = `/api/admin/fonts/${this.edit.id}`;

        const res = (
          await axios.post(url, formDataPost, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
        ).data;

        let message = "";
        if (this.upload) {
          message = this.$t("admin.engraving_text.success_upload");
        }
        if (this.edit) {
          message = this.$t("admin.engraving_text.success_edit");
        }
        const notification = {
          type: "success",
          message,
        };

        this.$store.dispatch("notification/add", notification, { root: true });
        this.$store.dispatch("fonts/fetch");
        this.$emit("success");
      } catch (error) {
        this.errors = error.response && error.response.data.errors;
        this.status = error.response && error.response.status;
        if (!error.response) console.log(error);
      } finally {
        this.loadingSaveData = false;
      }
    },
  },
};
</script>

